import React from 'react';
import { CheckIcon, ArrowDownIcon } from 'lucide-react';
import { heroPills } from '../data/content';
import { OFFER_ANCHOR } from '../utils/links';
export function Hero() {
  return <section className="relative overflow-hidden bg-cream" data-id="element-118" data-mp="9kjxeqt8b84q">
      <div className="pointer-events-none absolute -right-28 -top-28 hidden h-[440px] w-[440px] rounded-full bg-sage-tint/60 lg:block" aria-hidden="true" data-id="element-119" data-mp="9l34tdl96e4i" />

      <div className="relative mx-auto flex max-w-content flex-col px-5 pb-16 pt-10 sm:px-8 sm:pb-20 sm:pt-14 lg:grid lg:grid-cols-[1.02fr_0.98fr] lg:gap-x-16 lg:pb-28 lg:pt-20" data-id="element-120" data-mp="129qurmgy5roe">
        {/* Titular y subtítulo */}
        <div className="text-center lg:col-start-1 lg:row-start-1" data-id="element-121" data-mp="sa9slf0wlvx6">
          <p className="eyebrow flex items-center justify-center gap-2 text-[10px] text-clay sm:text-[11px]" data-id="element-122" data-mp="ncgjad4b0lso">
            <span aria-hidden="true" data-id="element-123" data-mp="3d21uq4bdkwqw">🌿</span> Armonía Interior
          </p>

          <h1 className="mt-5 text-[35px] font-semibold leading-[1.07] tracking-[-0.02em] text-ink sm:text-[50px] sm:leading-[1.05] lg:text-[60px] lg:leading-[1.03]" data-id="element-124" data-mp="382ffxqfwf8fz">
            Convierte tu casa en un espacio que te acompañe:{' '}
            <span className="text-clay" data-id="element-125" data-mp="3o6kfvj9sie5n">más calma, enfoque y armonía</span> en cada área de tu vida
          </h1>

          <p className="mx-auto mt-6 max-w-xl text-[16px] leading-[1.8] text-ink-soft sm:text-[17.5px]" data-id="element-126" data-mp="399jnddjryf64">
            Aprendé Feng Shui desde cero y descubrí cómo pequeños cambios en la distribución, los
            colores, los elementos y cada ambiente pueden ayudarte a crear un hogar más equilibrado
            y alineado con la vida que querés.
          </p>
        </div>

        {/* Imagen principal */}
        <div className="mt-10 lg:col-start-2 lg:row-start-1 lg:row-span-2 lg:mt-0 lg:self-center" data-id="element-127" data-mp="2qlelycqlb6ah">
          <div className="relative mx-auto w-full max-w-[360px] sm:max-w-[430px] lg:max-w-none" data-id="element-128" data-mp="2vj7tb93mq6cc">
            <img src="https://cdn.magicpatterns.com/uploads/3ZzeDWazVGh3D6sB4gLq2C/HERO.png" alt="Carolina Méndez sosteniendo la guía Armonía Interior en un ambiente luminoso" className="w-full rounded-[22px] object-cover shadow-lift" loading="eager" data-id="element-129" data-mp="2hjovb94j8bdr" />
            <div className="absolute -bottom-4 left-1/2 flex -translate-x-1/2 items-center gap-2.5 whitespace-nowrap rounded-full bg-white px-4 py-2.5 shadow-soft sm:-bottom-5 sm:px-5" data-id="element-130" data-mp="nat8vfsf4smt">
              <span className="text-[13px] font-semibold text-clay sm:text-sm" data-id="element-131" data-mp="ddf3cb819o9a">+2.400 hogares</span>
              <span className="h-3.5 w-px bg-sage-line" aria-hidden="true" data-id="element-132" data-mp="1b0nk5sx3a94y" />
              <span className="text-[12.5px] text-ink-soft sm:text-[13px]" data-id="element-133" data-mp="1ayjhtfeu9i6s">ya transformados</span>
            </div>
          </div>
        </div>

        {/* Etiquetas y CTA */}
        <div className="mt-14 lg:col-start-1 lg:row-start-2 lg:mt-10" data-id="element-134" data-mp="11151rgwtuvf0">
          

          <a href={OFFER_ANCHOR} className="mx-auto mt-8 flex w-full items-center justify-center gap-2.5 rounded-xl bg-clay px-6 py-5 text-center text-[14px] font-semibold uppercase tracking-[0.09em] text-white shadow-cta transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-clay-dark sm:text-[15px] lg:max-w-[480px]" data-id="element-135" data-mp="x0cqki4eagg3">
            Quiero transformar mi hogar
            <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-136" data-mp="21bpo3l0bc13u" />
          </a>

          <p className="mt-4 text-center text-[12.5px] text-ink-mute" data-id="element-137" data-mp="269r23rivta8g">
            Acceso inmediato · Formato digital · Incluye 5 bonus de regalo
          </p>
        </div>
      </div>
    </section>;
}